import { Button } from "antd";
import { FC, useEffect } from "react";
import { history, useModel } from "@umijs/max";
import dayjs from "dayjs";
import { useCookieState } from "ahooks";
import styles from "./index.less";

import { ReactComponent as PrimaryInfoIcon } from "@/assets/images/primary-info.svg";
import { ReactComponent as FoldIcon } from "@/assets/images/fold.svg";

import PlanExpired from "@packages/pricing-components/src/components/PlanExpired";
import {
  PricingPlanVersionEnum,
  PricingPlanVersionTextMap,
} from "@packages/pricing-components";

// 禁用逻辑
const disableScroll = () => {
  // 阻止滚轮事件
  document.addEventListener("wheel", preventScroll, { passive: false });
  // 阻止触摸事件（移动端）
  document.addEventListener("touchmove", preventScroll, { passive: false });
  // 阻止键盘方向键/空格键
  document.addEventListener("keydown", preventKeyScroll);
};

// 恢复逻辑
const enableScroll = () => {
  document.removeEventListener("wheel", preventScroll);
  document.removeEventListener("touchmove", preventScroll);
  document.removeEventListener("keydown", preventKeyScroll);
};

// 事件处理器
const preventScroll = (e: Event) => {
  e.preventDefault();
  e.stopPropagation();
  return false;
};

const preventKeyScroll = (e: KeyboardEvent) => {
  const keys = ["Space", "ArrowUp", "ArrowDown", "PageUp", "PageDown"];
  if (keys.includes(e.code)) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
};

interface ExpireNoticeAndBannedMaskProps {
  isExcludeBannedMask?: boolean;
}

const ExpireNoticeAndBannedMask: FC<ExpireNoticeAndBannedMaskProps> = ({
  isExcludeBannedMask = false,
}) => {
  const { initialState } = useModel("@@initialState");
  const userPlanSubscriptionInformation =
    initialState?.userPlanSubscriptionInformation;

  const [isFold, setIsFold] = useCookieState("is-expire-notice-fold", {
    defaultValue: "",
    expires: dayjs(dayjs().format("YYYY-MM-DD")).add(1, "day").toDate(),
  });

  useEffect(() => {
    if (userPlanSubscriptionInformation?.isExpired && !isExcludeBannedMask) {
      disableScroll();

      return () => {
        enableScroll();
      };
    }
  }, [userPlanSubscriptionInformation?.isExpired, isExcludeBannedMask]);

  return (
    <>
      <div className={styles["expire-notice"]}>
        <div className={styles.bar} onClick={() => setIsFold("")}></div>

        {!isFold && (
          <div className={styles.info}>
            <div className={styles.left}>
              <PrimaryInfoIcon />
              您订阅的 12Times ·&nbsp;
              {
                PricingPlanVersionTextMap[
                  userPlanSubscriptionInformation?.paidVersion ??
                    PricingPlanVersionEnum.BASIC
                ]
              }
              &nbsp;版将于&nbsp;
              {userPlanSubscriptionInformation?.expireAt}
              &nbsp;到期，逾期未续费将影响您的正常使用
            </div>
            <div className={styles.right}>
              <Button
                type="primary"
                onClick={() => {
                  history.push("/pricing", {
                    action: "renew",
                  });
                }}
              >
                立即续费
              </Button>
              <Button
                type="text"
                icon={<FoldIcon />}
                onClick={() => setIsFold("true")}
              />
            </div>
          </div>
        )}
      </div>

      {userPlanSubscriptionInformation?.isExpired && !isExcludeBannedMask && (
        <div className={styles["banned-mask"]}>
          <PlanExpired
            expiredVersion={
              userPlanSubscriptionInformation?.paidVersion ??
              PricingPlanVersionEnum.BASIC
            }
            expiredDate={userPlanSubscriptionInformation?.expireAt}
            onRenew={() => {
              history.push("/pricing", {
                action: "renew",
              });
            }}
          />
        </div>
      )}
    </>
  );
};

export default ExpireNoticeAndBannedMask;
